<template>
    <div class="otps-summary">
        <div class="full-container">
            <div class="top-navbar">
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <!-- <div class="top-navbar-left">
                            <select name="test" class="form-control input-dropdown">
                                <option value="123">123</option>
                                <option value="321">321</option>
                                <option value="567">567</option>
                            </select>
                        </div> -->
                    </div> 
                    
                    <div class="col-md-4">
                        <div class="top-navbar-center">
                            Consumer Validation
                            <small class="last-updated">Last updated on {{ latestUpdateTime }}</small>
                        </div>
                    </div>      

                    <div class="col-md-4">
                        <div class="top-navbar-right">
                            <button class="btn btn-ecdc btn-shadow" @click="$router.push({ name: 'otpsDetails' })">Otp Details</button>
                        </div>
                    </div>                       
                </div>
            </div>

            <hr />

            <div class="summary-list row row-cols-7">
                <div :key="data.id" class="col" v-for="data in weekData">
                    <div class="summary-blue-card">
                        <div class="card-content">
                            <h3 class="card-heading">
                                Day {{ data.day }}/{{ data.month }}
                                <small>Week {{ data.week }}</small>
                            </h3>

                            <div class="figure">
                                {{ numberWithCommas(data.total_sms, data.total_email) }}
                                <small>OTP Requested</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="data-card-list row row-cols-xl-3 row-cols-md-2 row-cols-1 mt-4">
                <div class="col">
                    <div class="card data-card">
                        <div class="row data-card-header">
                            <div class="col-md-6">
                                <h3 class="card-heading">
                                    SMS OTP Status
                                </h3>
                            </div>
                            <div class="col-md-6">
                                <ul class="nav nav-pills justify-content-end">
                                    <li class="nav-item">
                                        <span class="nav-link" :class="{ 'active' : smsChartStatus === 'year'}" @click="clickSmsChartStatus('year')">Year</span>
                                    </li>
                                    <li class="nav-item">
                                        <span class="nav-link" :class="{ 'active' : smsChartStatus === 'month'}" @click="clickSmsChartStatus('month')">Month</span>
                                    </li>
                                    <li class="nav-item">
                                        <span class="nav-link" :class="{ 'active' : smsChartStatus === 'week'}" @click="clickSmsChartStatus('week')">Week</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <app-bar-chart :chart-data="smsChartData" :options="chartOption" :height="250"></app-bar-chart>
                    </div>
                </div>
                <div class="col">
                    <div class="card data-card">
                        <div class="row data-card-header">
                            <div class="col-md-6">
                                <h3 class="card-heading">
                                    SMS OTP Total Verified
                                </h3>
                            </div>
                            <div class="col-md-6 text-md-right">
                                <select class="custom-select form-control" @change="getOtpByGraph" v-model="smsSuccessDropdown">
                                    <option :key="index" :value="data.year + '|' + data.week" v-for="(data, index) in graphDropdownData">{{ data.year }} | Week {{ data.week }} ({{ data.start_date }} - {{ data.end_date }})</option>
                                </select>
                            </div>
                        </div>

                        <h4 class="section-title">Top 10 Teams</h4>

                        <div class="row">
                            <div class="col-lg-6">
                                <dl :key="data.id" class="row no-gutters" v-for="(data, index) in smsSuccessData.slice(0, 5)">
                                    <dt class="col-1">{{ (index += 1) }}.</dt>
                                    <dt class="col-7">
                                        {{ data.team_name }}
                                    </dt>
                                    <dd class="col-4">
                                        {{ data.sms_verified_num }}
                                    </dd>
                                </dl>
                            </div>
                            <div class="col-lg-6" v-if="smsSuccessData.length > 5">
                                <dl :key="data.id" class="row no-gutters" v-for="(data, index) in smsSuccessData.slice(5, 10)">
                                    <dt class="col-1">{{ (index += 6) }}.</dt>
                                    <dt class="col-7">
                                        {{ data.team_name }}
                                    </dt>
                                    <dd class="col-4">
                                        {{ data.sms_verified_num }}
                                    </dd>
                                </dl>
                            </div>
                        </div>

                        
                    </div>
                </div>
                <div class="col">
                    <div class="card data-card">
                        <div class="row data-card-header">
                            <div class="col-md-6">
                                <h3 class="card-heading">
                                    SMS OTP Total Failed
                                </h3>
                            </div>
                            <div class="col-md-6 text-md-right">
                                <select class="custom-select form-control" @change="getOtpByGraph" v-model="smsFailDropdown">
                                    <option :key="index" :value="data.year + '|' + data.week" v-for="(data, index) in graphDropdownData">{{ data.year }} | Week {{ data.week }} ({{ data.start_date }} - {{ data.end_date }})</option>
                                </select>
                            </div>
                        </div>

                        <h4 class="section-title">Top 10 Area</h4>

                        <div class="row">
                            <div class="col-xl-6 col-lg-12 col-sm-6">
                                <dl :key="data.id" class="row no-gutters" v-for="(data, index) in smsFailedData.slice(0, 5)">
                                    <dt class="col-1">{{ (index += 1) }}.</dt>
                                    <dt class="col-7">
                                        {{ data.area_name }}
                                    </dt>
                                    <dd class="col-4">
                                        {{ data.sms_failure_num }}
                                    </dd>
                                </dl>
                            </div>
                            <div class="col-xl-6 col-lg-12 col-sm-6">
                                <dl :key="data.id" class="row no-gutters" v-for="(data, index) in smsFailedData.slice(5, 10)">
                                    <dt class="col-1">{{ (index += 6) }}.</dt>
                                    <dt class="col-7">
                                        {{ data.area_name }}
                                    </dt>
                                    <dd class="col-4">
                                        {{ data.sms_failure_num }}
                                    </dd>
                                </dl>
                            </div>
                        </div>

                        
                    </div>
                </div>
                <div class="col">
                    <div class="card data-card">
                        <div class="row data-card-header">
                            <div class="col-md-6">
                                <h3 class="card-heading">
                                    Email OTP Status
                                </h3>
                            </div>
                            <div class="col-md-6">
                                <ul class="nav nav-pills justify-content-end">
                                    <li class="nav-item">
                                        <span class="nav-link" :class="{ 'active' : emailChartStatus === 'year'}" @click="clickEmailChartStatus('year')">Year</span>
                                    </li>
                                    <li class="nav-item">
                                        <span class="nav-link" :class="{ 'active' : emailChartStatus === 'month'}" @click="clickEmailChartStatus('month')">Month</span>
                                    </li>
                                    <li class="nav-item">
                                        <span class="nav-link" :class="{ 'active' : emailChartStatus === 'week'}" @click="clickEmailChartStatus('week')">Week</span>
                                    </li>

                                </ul>
                            </div>
                        </div>
                        <app-bar-chart :chart-data="emailChartData" :options="chartOption" :height="250"></app-bar-chart>
                    </div>
                </div>
                <div class="col">
                    <div class="card data-card">
                        <div class="row data-card-header">
                            <div class="col-md-6">
                                <h3 class="card-heading">
                                    Email OTP Total Verified
                                </h3>
                            </div>
                            <div class="col-md-6 text-md-right">
                                <select class="custom-select form-control" @change="getOtpByGraph" v-model="emailSuccessDropdown">
                                    <option :key="index" :value="data.year + '|' + data.week" v-for="(data, index) in graphDropdownData">{{ data.year }} | Week {{ data.week }} ({{ data.start_date }} - {{ data.end_date }})</option>
                                </select>
                            </div>
                        </div>

                        <h4 class="section-title">Top 10 Teams</h4>

                        <div class="row">
                            <div class="col-xl-6 col-lg-12 col-sm-6">
                                <dl :key="data.id" class="row no-gutters" v-for="(data, index) in emailSuccessData.slice(0, 5)">
                                    <dt class="col-1">{{ (index += 1) }}.</dt>
                                    <dt class="col-7">
                                        {{ data.team_name }}
                                    </dt>
                                    <dd class="col-4">
                                        {{ data.email_verified_num }}
                                    </dd>
                                </dl>
                            </div>
                            <div class="col-xl-6 col-lg-12 col-sm-6">
                                <dl :key="data.id" class="row no-gutters" v-for="(data, index) in emailSuccessData.slice(5, 10)">
                                    <dt class="col-1">{{ (index += 6) }}.</dt>
                                    <dt class="col-7">
                                        {{ data.team_name }}
                                    </dt>
                                    <dd class="col-4">
                                        {{ data.email_verified_num }}
                                    </dd>
                                </dl>
                            </div>
                        </div>

                        
                    </div>
                </div>
                <div class="col">
                    <div class="card data-card">
                        <div class="row data-card-header">
                            <div class="col-md-6">
                                <h3 class="card-heading">
                                    Email OTP Total Failed
                                </h3>
                            </div>
                            <div class="col-md-6 text-md-right">
                                <select class="custom-select form-control" @change="getOtpByGraph" v-model="emailFailDropdown">
                                    <option :key="index" :value="data.year + '|' + data.week" v-for="(data, index) in graphDropdownData">{{ data.year }} | Week {{ data.week }} ({{ data.start_date }} - {{ data.end_date }})</option>
                                </select>
                            </div>
                        </div>

                        <h4 class="section-title">Top 10 Area</h4>

                        <div class="row">
                            <div class="col-xl-6 col-lg-12 col-sm-6">
                                <dl :key="data.id" class="row no-gutters" v-for="(data, index) in emailFailedData.slice(0, 5)">
                                    <dt class="col-1">{{ (index += 1) }}.</dt>
                                    <dt class="col-7">
                                        {{ data.area_name }}
                                    </dt>
                                    <dd class="col-4">
                                        {{ data.email_failure_num }}
                                    </dd>
                                </dl>
                            </div>
                            <div class="col-xl-6 col-lg-12 col-sm-6">
                                <dl :key="data.id" class="row no-gutters" v-for="(data, index) in emailFailedData.slice(5, 10)">
                                    <dt class="col-1">{{ (index += 6) }}.</dt>
                                    <dt class="col-7">
                                        {{ data.area_name }}
                                    </dt>
                                    <dd class="col-4">
                                        {{ data.email_failure_num }}
                                    </dd>
                                </dl>
                            </div>
                        </div>

                        
                    </div>
                </div>
                
            </div>

            <app-loader v-show="isLoading"></app-loader>

        </div>
    </div>
</template>

<script>
import { checkPermission, getOtpByWeek, getOtpByGraph, getOtpByChart, getGraphDateDropdown } from '../api'
import BarChart from './chart/BarChart.vue'
import Loader from "./Loader";

export default {
    components: {
        appBarChart: BarChart,
        appLoader: Loader,
    },
    data() {
        return {
            smsChartStatus: 'week',
            emailChartStatus: 'week',
            restrictViewUsers: false,
            isLoading: true,
            weekData: '',
            smsChartData: {},
            emailChartData: {},
            latestUpdateTime: '',
            smsSuccessData: '',
            smsFailedData: '',
            emailSuccessData: '',
            emailFailedData: '',
            graphDropdownData: '',
            smsSuccessDropdown: '',
            smsFailDropdown: '',
            emailSuccessDropdown: '',
            emailFailDropdown: '',
            chartOption: {
                scales: {
                    xAxes: [{
                        stacked: true,
                        gridLines: {
                            drawOnChartArea: false,
                            color: '#2B4162',
                            offsetGridLines: false,
                        }
                    }],
                    yAxes: [{
                        stacked: true,
                        gridLines: {
                            drawOnChartArea: false,
                            color: '#2B4162',
                            offsetGridLines: false
                        }
                    }],
                },
                legend: {
                    labels: {
                        boxWidth: 10,
                    },
                }
            }
        }
    },
    async mounted() {

        this.restrictViewUsers = await this.checkPermission('restrict users');

        await this.getGraphDateDropdown();
        await this.getChart();
        await this.getOtpByWeek();
        await this.getOtpByGraph();
        this.isLoading = false;
    },
    methods: {
        async checkPermission(permission) {

            try {
                const result = await checkPermission({permission:permission});
                return result.data.data;
            }
            catch(err) {
                return false;
            }
        },
        async getOtpByWeek() {

            try {
                let result = await getOtpByWeek();
                this.isLoading = true;
                this.weekData = result.data.otpByWeek;
                this.latestUpdateTime = result.data.last_updated
            } catch (err) {
                alert(err.response.data.message);
            }

        },
        async getOtpByGraph() {
            try {
                let result = await getOtpByGraph({smsSuccess: this.smsSuccessDropdown, smsFail: this.smsFailDropdown, emailSuccess: this.emailSuccessDropdown, emailFail: this.emailFailDropdown});
                this.isLoading = true;
                this.smsSuccessData = result.data.sms_success;
                this.smsFailedData = result.data.sms_failed;
                this.emailSuccessData = result.data.email_success;
                this.emailFailedData = result.data.email_failed;

            } catch(err) {
                alert(err.response.data.message);
            }
        },
        async getChart() {
            try {
                let result = await getOtpByChart();
                this.isLoading = true;
                this.chartData = result.data;
                this.filterSmsChart();
                this.filterEmailChart();
            } catch(err) {
                alert(err.response.data.message);
            }

        },
        async getGraphDateDropdown() {
            try {
                let result = await getGraphDateDropdown();
                this.isLoading = true;
                this.graphDropdownData = result.data;
                this.smsSuccessDropdown = this.graphDropdownData[0]["year"] + '|' + this.graphDropdownData[0]["week"];
                this.smsFailDropdown = this.graphDropdownData[0]["year"] + '|' + this.graphDropdownData[0]["week"];
                this.emailSuccessDropdown = this.graphDropdownData[0]["year"] + '|' + this.graphDropdownData[0]["week"];
                this.emailFailDropdown = this.graphDropdownData[0]["year"] + '|' + this.graphDropdownData[0]["week"];

            } catch(err) {
                alert(err.response.data.message);
            }
        },
        filterSmsChart() {
            let labels = [];
            let success = [];
            let fail = [];
            switch(this.smsChartStatus) {
                case 'year':
                    this.chartData.sms_yearly.slice().reverse().forEach(item => {
                        labels.push(item.year);
                        success.push(item.sms_success);
                        fail.push(item.sms_failed);
                    });
                    break;
                case 'month':
                    this.chartData.sms_monthly.slice().reverse().forEach(item => {
                        labels.push(item.month + ' ' + item.year);
                        success.push(item.sms_success);
                        fail.push(item.sms_failed);
                    });
                    break;
                case 'week':
                    this.chartData.sms_weekly.slice().reverse().forEach(item => {
                        labels.push('Week ' + item.week);
                        success.push(item.sms_success);
                        fail.push(item.sms_failed);
                    });
                    break;
            }

            this.smsChartData = {
                labels: labels,

                datasets: [
                    {
                        label: 'Success',
                        data: success,
                        backgroundColor: '#FDCD08'
                    },
                    {
                        label: 'Failed',
                        data: fail,
                        backgroundColor: '#2B4162'
                    }
                ],


            }
        },
        filterEmailChart() {
            let labels = [];
            let success = [];
            let fail = [];
            switch(this.emailChartStatus) {
                case 'year':
                    this.chartData.email_yearly.slice().reverse().forEach(item => {
                        labels.push(item.year);
                        success.push(item.email_success);
                        fail.push(item.email_failed);
                    });
                    break;
                case 'month':
                    this.chartData.email_monthly.slice().reverse().forEach(item => {
                        labels.push(item.month + ' ' + item.year);
                        success.push(item.email_success);
                        fail.push(item.email_failed);
                    });
                    break;
                case 'week':
                    this.chartData.email_weekly.slice().reverse().forEach(item => {
                        labels.push('Week ' + item.week);
                        success.push(item.email_success);
                        fail.push(item.email_failed);
                    });
                    break;
            }

            this.emailChartData = {
                labels: labels,

                datasets: [
                    {
                        label: 'Success',
                        data: success,
                        backgroundColor: '#FDCD08'
                    },
                    {
                        label: 'Failed',
                        data: fail,
                        backgroundColor: '#2B4162'
                    }
                ],


            }
        },
        clickSmsChartStatus(type) {
            this.smsChartStatus = type;
            this.filterSmsChart();
        },
        clickEmailChartStatus(type) {
            this.emailChartStatus = type;
            this.filterEmailChart();
        },
        numberWithCommas(x, y) {
            let total = x + y;

            if(total.toString().length === 7) {
                return Math.round((total/1000000)) + "M"
            } else {
                return total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }

        }
    }
}
</script>